export const keepSearchParams = [
  "park_id",
  "iframe",
  "skip_vehicle",
  "skip_license",
  "theme",
  "ref_id",
  "lang",
  "sessionId",
] as const;
